import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e439e4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-2xl font-bold" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "value", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.question.question), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answers, (answer) => {
      return (_openBlock(), _createElementBlock("label", {
        key: answer.idx,
        for: answer.idx,
        class: _normalizeClass(["block mt-4 border border-gray-300 rounded-lg py-2 px-6 text-lg cursor-pointer", {'selected-answer' : (_ctx.question.selectedAnswer == answer), 'hover:bg-gray-100' : (_ctx.question.selectedAnswer != answer) }])
      }, [
        _createElementVNode("input", {
          id: answer.idx,
          type: "radio",
          class: "hidden",
          value: answer.idx,
          onClick: ($event: any) => (_ctx.questionAnswered(answer))
        }, null, 8, _hoisted_3),
        _createTextVNode(" " + _toDisplayString(answer.answer), 1)
      ], 10, _hoisted_2))
    }), 128))
  ], 64))
}